<information-detail-tag>
<style>
a {
  color: #4C19AF
}
</style>

<div class="contents contents-wide">
  <section class="contents_area">
    <div class="container_heading">
      <h1 class="heading-01 heading_news">お知らせ</h1>
      <ul class="breadcrumb">
        <li class="breadcrumb-item"><a href="/menu" class="home">ホーム</a></li>
        <li class="breadcrumb-item"><a href="/menu/information">お知らせ</a></li>
        <li class="breadcrumb-item">詳細</li>
      </ul>
    </div><!--/.container_heading-->
    <div class="contents_block detail">
      <div class="container_detail-heading">
        <div class="date-label">
          <span class="date">{state.info.created_at}</span>
          <span class="label {informationLabel(state.info.service)}"></span>
        </div>
        <h2 class="detail-heading">{state.info.title}</h2>
      </div><!--/.container_detail-title-->
      
      <div class="container_detail-text">
        <p style="white-space:pre-wrap"><raw-tag html={convertLink(state.info.body)}></raw-tag></p>
      </div><!--/.container_detail-text-->
      
      <ul class="link_list">
        <li class="link_list-item"><a onclick={(e)=>back(e)}>お知らせ一覧に戻る</a></li>
      </ul>
      
    </div><!--/.contents_block-->
  </section><!--/.contents_area-->
</div><!--/.contents-->

<script>
  import di from "dependeny-injection";
  import InformationLabel from "@model/information-label.js";
  export default {
    informationLabel: InformationLabel.get,
    informationId: false,
    state: {
      info: {},
    },
    convertLink(body){
      if (!body) { return ''}
      return body.replace(/(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig,"<a href='$1'>$1</a>");
    },
    back(e){
      e.preventDefault();
      history.back();
    },
    onBeforeMount(props, state){
      this.MenuApi = di.createApi();
      this.MenuApi.request('information', 'detail', {id: props.routeParams[0]})
        .then(data => this.update({info: data}));
    }
  }
</script>
</information-detail-tag>
